export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9851.f19cdac1.jpg";